import PageHero from "@/components/PageHero";

export default function MissionPage() {
    return (
        <div data-testid="mission-page">
            <PageHero
                eyebrow="About BENNE"
                title="Our Mission"
                lead="Amplify the chefs, makers, farmers and operators whose work has shaped food & hospitality but whose names have rarely shaped the headlines."
                breadcrumbs={[
                    { label: "Home", to: "/" },
                    { label: "About", to: "/about" },
                    { label: "Mission" },
                ]}
            />
            <div className="px-4 md:px-8 lg:px-12 py-16 max-w-3xl font-sofia text-lg text-[#1B1B1B]/85 leading-[1.8] space-y-6">
                <h2 className="font-poppins font-bold text-2xl md:text-3xl text-[#E63B26]">
                    At Benne, we understand that the food and hospitality
                    industry is all about connection, culture, and community.
                </h2>
                <h3 className="font-poppins font-semibold text-xl md:text-2xl text-[#1B1B1B]">
                    We believe that your passion deserves recognition, and we
                    use powerful digital marketing tools to help you build a
                    loyal customer base.
                </h3>
                <p>
                    We are committed to supporting businesses that reflect
                    diversity in leadership, hospitality, cuisine, and
                    experience.
                </p>
                <p>
                    Our personalized approach ensures that your brand&apos;s
                    unique story is shared with the world, bringing authentic
                    engagement and growth.
                </p>
                <h2 className="font-poppins font-bold text-2xl text-[#E63B26] pt-4">
                    How we work
                </h2>
                <ol className="list-decimal pl-6 space-y-3">
                    <li>
                        We never accept sponsored content disguised as
                        editorial.
                    </li>
                    <li>
                        We run a public, transparent submissions process.
                    </li>
                    <li>
                        We prioritize under-represented community and BIPOC-led
                        programming.
                    </li>
                    <li>
                        We try our best to correct on the record, fast, and in
                        public.
                    </li>
                </ol>
                <h2 className="font-poppins font-bold text-2xl text-[#E63B26] pt-4">
                    Who we cover
                </h2>
                <p>
                    Chefs, restaurateurs, sommeliers, bakers, farmers, hotel
                    operators, hospitality interior designers, beverage makers,
                    tour operators, food educators, food justice organizers,
                    and the people who feed our cities — particularly but not
                    limited to Black, Indigenous, queer, women-led,
                    immigrant-led, and differently-abled voices.
                </p>
            </div>
        </div>
    );
}
